export default [
  {
    text: "Room Name",
    value: "roomName",
    iconName: "room-name-gray",
    icon:
      '<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.92 40.07">\n' +
      "  <defs>\n" +
      "    <style>\n" +
      "      .cls-1 {\n" +
      "        fill: #F8BF1E;\n" +
      "        stroke-width: 0px;\n" +
      "      }\n" +
      "    </style>\n" +
      "  </defs>\n" +
      '  <g id="V4_copy" data-name="V4 copy">\n' +
      "    <g>\n" +
      "      <g>\n" +
      '        <path class="cls-1" d="m14.91,0L4.33,2.86c-.22.06-.37.26-.37.48v33.93c0,.27-.22.49-.49.49H.49c-.27,0-.49-.22-.49-.49V.5C0,.22.22,0,.49,0h14.42Z"/>\n' +
      '        <path class="cls-1" d="m24.61.49v17.5l-3.96,3.96V3.96h-.94V0h4.4c.28,0,.49.23.49.49Z"/>\n' +
      '        <path class="cls-1" d="m21.17,28.53l3.44-3.44v12.18c0,.28-.22.49-.49.49h-2.97c-.27,0-.49-.22-.49-.49v-8.4c.19-.07.37-.19.51-.35Z"/>\n' +
      '        <path class="cls-1" d="m11.35,18.7c-.66.66-.66,1.74,0,2.4l7.38,7.39v10.59c0,.62-.55,1.09-1.17.97l-12.21-2.29c-.24-.04-.41-.25-.41-.48V4.1c0-.23.15-.42.37-.48L17.48.34c.63-.17,1.25.31,1.25.95v20.1l-3.84-3.83c-.32-.33-.74-.5-1.2-.5s-.88.18-1.21.5l-1.14,1.14Z"/>\n' +
      "      </g>\n" +
      '      <path class="cls-1" d="m19.47,27.83l-7.43-7.43c-.28-.28-.28-.73,0-1l1.14-1.14c.28-.28.73-.28,1,0l5.28,5.28c.28.28.73.28,1,0l11.09-11.09c.28-.28.73-.28,1,0l1.14,1.14c.28.28.28.73,0,1l-13.24,13.24c-.28.28-.73.28-1,0Z"/>\n' +
      "    </g>\n" +
      "  </g>\n" +
      "</svg>",
  },
  {
    text: "Room ID",
    value: "customRoomId",
    iconName: "room-menu",
    icon:
      '<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.73 40.73">\n' +
      "  <defs>\n" +
      "    <style>\n" +
      "      .cls-1 {\n" +
      "        fill: #F8BF1E;\n" +
      "        stroke-width: 0px;\n" +
      "      }\n" +
      "    </style>\n" +
      "  </defs>\n" +
      '  <g id="V4_copy" data-name="V4 copy">\n' +
      "    <g>\n" +
      '      <path class="cls-1" d="m20.36,4c9.02,0,16.36,7.34,16.36,16.36s-7.34,16.36-16.36,16.36S4,29.39,4,20.36,11.34,4,20.36,4m0-4C9.12,0,0,9.12,0,20.36s9.12,20.36,20.36,20.36,20.36-9.12,20.36-20.36S31.61,0,20.36,0h0Z"/>\n' +
      '      <rect class="cls-1" x="12.02" y="13.63" width="16.69" height="3.56" rx="1.78" ry="1.78"/>\n' +
      '      <rect class="cls-1" x="12.02" y="18.08" width="16.69" height="3.56" rx="1.78" ry="1.78"/>\n' +
      '      <rect class="cls-1" x="12.02" y="22.54" width="9.17" height="3.56" rx="1.78" ry="1.78"/>\n' +
      "    </g>\n" +
      "  </g>\n" +
      "</svg>",
  },
  {
    text: "Status",
    value: "status",
    iconName: "room-status-purple",
    icon:
      '<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.73 40.73">\n' +
      "  <defs>\n" +
      "    <style>\n" +
      "      .cls-1 {\n" +
      "        fill: #F8BF1E;\n" +
      "        stroke-width: 0px;\n" +
      "      }\n" +
      "    </style>\n" +
      "  </defs>\n" +
      '  <g id="V4_copy" data-name="V4 copy">\n' +
      "    <g>\n" +
      '      <path class="cls-1" d="m20.36,4c9.02,0,16.36,7.34,16.36,16.36s-7.34,16.36-16.36,16.36S4,29.39,4,20.36,11.34,4,20.36,4m0-4C9.12,0,0,9.12,0,20.36s9.12,20.36,20.36,20.36,20.36-9.12,20.36-20.36S31.61,0,20.36,0h0Z"/>\n' +
      "      <g>\n" +
      '        <path class="cls-1" d="m12.3,17.33c-1.67,0-3.03,1.36-3.03,3.03s1.36,3.03,3.03,3.03,3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03h0Z"/>\n' +
      '        <path class="cls-1" d="m20.36,17.33c-1.67,0-3.03,1.36-3.03,3.03s1.36,3.03,3.03,3.03,3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03h0Z"/>\n' +
      '        <path class="cls-1" d="m28.43,17.33c-1.67,0-3.03,1.36-3.03,3.03s1.36,3.03,3.03,3.03,3.03-1.36,3.03-3.03-1.36-3.03-3.03-3.03h0Z"/>\n' +
      "      </g>\n" +
      "    </g>\n" +
      "  </g>\n" +
      "</svg>",
  },
  {
    text: "Friends",
    value: "members",
    iconName: "friends-gray",
    // width: "20%",
    icon:
      '<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.16 41.68">\n' +
      "  <defs>\n" +
      "    <style>\n" +
      "      .cls-1 {\n" +
      "        fill: #F8BF1E;\n" +
      "        stroke-width: 0px;\n" +
      "      }\n" +
      "    </style>\n" +
      "  </defs>\n" +
      '  <g id="V4_copy" data-name="V4 copy">\n' +
      "    <g>\n" +
      "      <g>\n" +
      '        <circle class="cls-1" cx="29.08" cy="10.68" r="10.68"/>\n' +
      '        <path class="cls-1" d="m41.06,41.68h-23.95c-3.43,0-5.97-3.19-5.21-6.53,1.82-8,6.66-12.34,8.92-13.99,2.27,1.8,5.15,2.88,8.27,2.88s5.99-1.08,8.27-2.88c2.26,1.64,7.11,5.99,8.92,13.99.76,3.34-1.78,6.53-5.21,6.53Z"/>\n' +
      "      </g>\n" +
      "      <g>\n" +
      '        <path class="cls-1" d="m53.29,13.37c0,4.34-3.53,7.86-7.87,7.86-2.5,0-4.73-1.17-6.17-3,1.58-2.11,2.52-4.72,2.52-7.55,0-1.36-.21-2.67-.62-3.9,1.22-.8,2.69-1.26,4.27-1.26,4.34,0,7.87,3.51,7.87,7.85Z"/>\n' +
      '        <path class="cls-1" d="m54.23,36.17h-5.82c-.02-.48-.08-.97-.19-1.46-1.28-5.66-4-9.65-6.38-12.2,1.11.45,2.32.69,3.58.69,2.3,0,4.41-.8,6.08-2.12,1.67,1.21,5.23,4.41,6.56,10.29.56,2.46-1.3,4.8-3.83,4.8Z"/>\n' +
      "      </g>\n" +
      "      <g>\n" +
      '        <path class="cls-1" d="m18.91,18.23c-1.43,1.83-3.66,3-6.16,3-4.34,0-7.87-3.52-7.87-7.86s3.53-7.85,7.87-7.85c1.58,0,3.05.46,4.27,1.26-.41,1.23-.62,2.54-.62,3.9,0,2.83.94,5.44,2.51,7.55Z"/>\n' +
      '        <path class="cls-1" d="m16.33,22.52c-2.38,2.55-5.1,6.54-6.38,12.19-.11.49-.17.98-.19,1.46H3.94c-2.52,0-4.39-2.34-3.84-4.8,1.34-5.88,4.9-9.08,6.56-10.29,1.68,1.32,3.79,2.12,6.09,2.12,1.26,0,2.47-.24,3.58-.68Z"/>\n' +
      "      </g>\n" +
      "    </g>\n" +
      "  </g>\n" +
      "</svg>",
  },
];
